<template>
  <div>
    <!--<BeneficiaryModal ref="benefModal" />
			<PropertyTitleModal ref="ptModal" />
      PASO 3 DE LA MUERTE!!!!!!!
    <RecommendationsModal ref="recomModal" /> -->
    <div style="background-color: #fff; padding-bottom: 30px;">
      <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img :src="isReadyToFinish ? '/img/progress/W05.svg' : '/img/progress/W04.svg'"
              style="width: 100%; height: auto;" alt />
          </div>
        </mdb-row>
      </mdb-container>
    </div>
    <div style="background-color: #f7f7f7;" class="mt-1 pt-1 cardClass">
      <mdb-container
        style="max-width: 97% !important; padding-bottom: 2rem; background-color: #fff; -webkit-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); -moz-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34);"
        class="mt-5">
        <mdb-row class="pt-5 pr-5">
          <mdb-col md="8" class="text-center">
            <span class="text-style"></span>
          </mdb-col>
          <mdb-col md="1" class="text-right" style="margin-left: 24%;">
            <p style="font-size: 30px; cursor: pointer; color: #e0e0e0; font-weight: 700;" @click="closeMessageError()">
              x</p>
          </mdb-col>
        </mdb-row>

        <div class="documents-section mb-5">
          <!-- SECCIÓN DATOS PERSONALES ========================== -->
          <div class="info mb-3">
            <div class="t1-table-title-left text-uppercase">Usuarios</div>
            <div class="t1-subtitle" style="font-size:18px">Completa tus datos y agrega los documentos requeridos</div>
          </div>

          <div class="accordion-section">
            <Accordion title="Titular">
              <!--TITULAR-->

              <!-- PERSONALES -->
              <div class="accordion-header">Personales</div>
              <div class="accordion-content">
                <BeneficiaryPersonalData class="form-content" />
              </div>

              <!-- DE CONTACTO -->
              <div class="accordion-header">De contacto</div>
              <div class="accordion-content">
                <BeneficiaryContactData ref="contactBeneficiaryData" class="form-content" />
              </div>

              <!-- DE DOMICILIO -->
              <div class="accordion-header">Domicilio</div>
              <div class="accordion-content">
                <BeneficiaryHomeData ref="HomeBeneficiaryData" class="form-content" />
              </div>

              <!-- CONTACTO DE EMERGENCIA -->
              <div class="accordion-header">Contacto de Emergencia</div>
              <div class="accordion-content">
                <BeneficiaryEmergencyContact ref="EmergBeneficiaryData" class="form-content" />
              </div>

              <!-- LABORALES -->
              <div class="accordion-header">Laborales</div>
              <div class="accordion-content">
                <BeneficiaryWorkingData class="form-content" />
              </div>

              <!-- FACTURACIÓN -->
              <div class="accordion-header">Datos de facturación</div>
              <div class="accordion-content">
                <BeneficiaryBillData ref="BeneficiaryBillingData" class="form-content" />
              </div>
            </Accordion>

            <Accordion title="Cónyuge" v-if="showDataSpouse">
              <!-- PERSONALES -->
              <div class="accordion-header">Personales</div>
              <div class="accordion-content">
                <SpousePersonalData class="form-content" />
              </div>

              <!-- DE CONTACTO -->
              <div class="accordion-header">De contacto</div>
              <div class="accordion-content">
                <SpouseContactData ref="contactSpouseData" class="form-content" />
              </div>

              <!-- DE CONTACTO -->
              <div class="accordion-header">Domicilio</div>
              <div class="accordion-content">
                <SpouseHomeData ref="homeSpouseData" class="form-content" />
              </div>

              <!-- CONTACTO DE EMERGENCIA -->
              <div class="accordion-header">Contacto de Emergencia</div>
              <div class="accordion-content">
                <SpouseEmergencyContact ref="EmergSpouseData" class="form-content" />
              </div>

              <!-- LABORALES -->
              <div class="accordion-header">Laborales</div>
              <div class="accordion-content">
                <SpouseWorkingData class="form-content" />
              </div>
            </Accordion>

            <div v-for="(item, index) in childs" v-bind:key="index">
              <!-- HIJ@ MENOR-->
              <Accordion :index="index" :key="index" :title="item ? 'Hij@ Mayor' : 'Hij@ Menor'"
                @delete="deleteChildren">
                <div class="accordion-header">Personales</div>
                <div class="accordion-content">
                  <ChildPersonalData :key="index" :isMayor="item" :index="index" :ref="'ChildPersonalData' + index"
                    class="form-content" />
                </div>

                <div class="accordion-header">Domicilio</div>
                <div class="accordion-content">
                  <ChildHomeData :key="index" :index="index" :ref="'ChildHomeData' + index" class="form-content" />
                </div>

                <div class="accordion-header">Contacto de Emergencia</div>
                <div class="accordion-content">
                  <ChildEmergencyContact :key="index" :index="index" :ref="'ChildEmergencyContact' + index"
                    class="form-content" />
                </div>

                <div v-if="item" class="accordion-header">Laborales</div>
                <div v-if="item" class="accordion-content">
                  <ChildWorkingData class="form-content" :ref="'ChildWorkingData' + index" :index="index" />
                </div>
              </Accordion>

              <!-- HIJ@ MAYOR-->
              <!-- <Accordion :key="index" title="Hij@ Mayor" v-if="item">
                <div class="accordion-header">Personales</div>
                <div class="accordion-content">
                  <ChildPersonalData
                    :key="index"
                    :isMayor="true"
                    :ref="'ChildPersonalData'+index"
                    class="form-content"
                  />
                </div>

                <div class="accordion-header">Domicilio</div>
                <div class="accordion-content">
                  <ChildHomeData :key="index" :ref="'ChildHomeData'+index" class="form-content" />
                </div>

                <div class="accordion-header">Contacto de Emergencia</div>
                <div class="accordion-content">
                  <ChildEmergencyContact
                    :key="index"
                    :ref="'ChildEmergencyContact'+index"
                    class="form-content"
                  />
                </div>

                <div class="accordion-header">Laborales</div>
                <div class="accordion-content">
                  <ChildWorkingData class="form-content" :ref="'ChildWorkingData'+index" />
                </div>
              </Accordion> -->
            </div>
          </div>
          <!--accordion-section-->

          <div v-if="childs.length < 8 && showDataMenorChilds" class="btn-section">
            <div class="btn-show-child">
              <Btn type="primary-block2" icon="plus" text="Agregar hij@" class="btn-add-child"
                @onClick="$refs.childPopUp.toggleModal();" />
            </div>
            <div style="clear:both"></div>
          </div>
          <!-- btn-section-->

          <!-- SECCIÓN AUTOS ========================== -->

          <div class="info mb-3">
            <div class="t1-table-title-left text-uppercase">AUTOS TITULAR</div>
            <div class="t1-subtitle" style="font-size:18px">Ingresa los datos de por lo menos un vehículo de tu
              pertenencia</div>
          </div>

          <!-- AUTOS -->
          <div v-for="(item, index) in cars" :key="index" class="accordion-section">
            <Accordion :key="index" :title="'Auto ' + (index + 1)" :index="index" @delete="deleteCar(index)">
              <div class="accordion-header">Auto 0{{ index + 1 }}</div>
              <div class="accordion-content">
                <BeneficiaryAutosData :ref="'AutosBeneficiaryData' + index" :index="index" class="form-content" />
              </div>
            </Accordion>
          </div>

          <div v-if="cars.length < 7" class="btn-section">
            <div class="btn-show-child">
              <Btn type="primary-block2" icon="plus" text="Agregar auto" class="btn-add-child" @onClick="addCar" />
            </div>
            <div style="clear:both"></div>
          </div>

          <!-- SECCIÓN AUTOS ========================== -->

          <div class="info mb-3">
            <div class="t1-table-title-left text-uppercase">RECOMENDACIONES DE SOCIOS</div>
          </div>

          <!-- AUTOS -->
          <div class="accordion-section">
            <Accordion title="Recomendaciones socios">
              <div class="accordion-content">
                <BeneficiaryRecomendationsData class="form-content" />
              </div>
            </Accordion>
          </div>
        </div>
        <!-- documents-section -->

        <mdb-row class="mt-5">
          <mdb-col>
            <div class="btn-submit-docs">
              <!-- saveBenaficiaryData-->
              <btn @onClick="closeMessageError()" style="display: inline; padding-right: 1rem;"
                :type="'primary-admin-ghost'" :text="'Salir'" />
              <btn v-show="!isReadyToFinish" @onClick="checkDataJson" style="display: inline; padding-right: 1rem;"
                :type="'primary-admin-ghost'" :text="'Guardar'" />
              <btn v-show="isReadyToFinish" @onClick="$refs.toFinish.toggleModal()" style="display: inline;"
                :type="'primary-block'" :text="'Finalizar'" />
              <!-- <btn v-else style="display: inline;" :type="'disabled'" :text="'Finalizar'" /> -->
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>

    <Popup ref="childPopUp" size="sm-mod2">
      <div class="text-center">
        <h1 class="text-center title-pop-child">ANTES DE CONTINUAR:</h1>
        <p class="subtitle-pop-child">¿Es tu hij@ mayor de edad (18+)?</p>

        <mdb-row>
          <mdb-col md="4" style="margin-bottom: 10px;"></mdb-col>
          <mdb-col md="2" style="margin-bottom: 20px;">
            <div class="form__group">
              <div class="custom-control custom-radio custom-control-inline radio-buttons">
                <input type="radio" value="mayorChild" v-model="selectedChild" class="custom-control-input"
                  id="groupChild1" name="groupOfchild" />
                <label class="custom-control-label" for="groupChild1">Sí</label>
              </div>
            </div>
          </mdb-col>

          <mdb-col md="2" style="margin-bottom: 20px;">
            <div class="form__group">
              <div class="custom-control custom-radio custom-control-inline radio-buttons">
                <input type="radio" value="menorChild" v-model="selectedChild" class="custom-control-input"
                  id="groupChild2" name="groupOfchild" />
                <label class="custom-control-label" for="groupChild2">No</label>
              </div>
            </div>
          </mdb-col>

          <mdb-col md="4" style="margin-bottom: 10px;"></mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col md="1" style="margin-bottom: 10px;"></mdb-col>
          <mdb-col md="10" style="margin-bottom: 10px;">
            <p class="text-pop-child">
              <span style="color: #dc7134; font-weight: 600;">Importante:</span>
              <span style="font-weight: 600;">SE APLICARÁ UNA CUOTA ADICIONAL, POR CADA HIJO CON EDAD DE 26(VEINTISÉIS) AÑOS CUMPLIDOS EN ADELANTE.
                FAVOR DE CONSULTAR CUOTAS VIGENTES CON SU ASESOR DE VENTAS.</span>
            </p>
          </mdb-col>
          <mdb-col md="1" style="margin-bottom: 10px;"></mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col md="3" style="margin-bottom: 10px;"></mdb-col>

          <mdb-col md="3" style="margin-bottom: 10px;">
            <btn type="ghost" text="Cancelar" @onClick="$refs.childPopUp.toggleModal();" />
          </mdb-col>

          <mdb-col md="3" style="margin-bottom: 10px;">
            <btn type="primary-block" text="Continuar" @onClick="addChild" />
          </mdb-col>

          <mdb-col md="3" style="margin-bottom: 10px;"></mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup ref="savePopup" size="sm">
      <div class="text-center">
        <h2 class="text-center title-pop-child">DOCUMENTACIÓN GUARDADA CORRECTAMENTE</h2>

        <mdb-row>
          <mdb-col md="12" style="margin-bottom: 10px;">
            <p class="text-pop-child text-center">Tu documentación y datos han sido guardados. No olvides regresar para
              completar la documentación</p>
          </mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col md="4" style="margin-bottom: 10px;"></mdb-col>

          <mdb-col md="4" style="margin-bottom: 10px;">
            <btn type="primary-block" text="OK" @onClick="closeSavedPoUp" />
          </mdb-col>

          <mdb-col md="4" style="margin-bottom: 10px;"></mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup size="sm" ref="toFinish">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="font-family: Josefin Sans;
  font-size: 19px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #dc7134;">
                <span class="text-center" style="margin-left: 6rem;">FINALIZAR DOCUMENTACIÓN</span>
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div style="font-family: Open Sans;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f4f4f;
    text-align: center;
    padding: 0rem 2rem;">Tus documentos y datos serán enviados y ya no podrás editar nada.</div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem;">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%;">
                <Btn @onClick="send" :text="'Enviar'" :type="'primary-admin'" style="float:right;"></Btn>
                <Btn @onClick="$refs.toFinish.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"
                  style="float:right; margin-right: 1rem;"></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
    <Loader v-show="isLoading" />
  </div>
</template>



<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import Input from "../core/Input";
import Btn from "../core/Button";
import { mapGetters, mapActions } from "vuex";
import Popup from "../core/Popup";
import Swal from "sweetalert2";
import { toDataURL } from "../../utils/utils"

//import BeneficiaryModal from "../content/BeneficiaryModal";
//import PropertyTitleModal from "../content/PropertyTitleModal";
//import RecommendationsModal from "../content/RecommendationsModal";
import Accordion from "../core/Accordion";
import AccordionHeader from "../core/Accordion/Header";
import ValidationError from "./misc/ValidationError";
import { required, email } from "vuelidate/lib/validators";
import BeneficiaryPersonalData from "../content/Beneficiary/BeneficiaryPersonalData";
import BeneficiaryContactData from "../content/Beneficiary/BeneficiaryContactData";
import BeneficiaryHomeData from "../content/Beneficiary/BeneficiaryHomeData";
import BeneficiaryAutosData from "../content/Beneficiary/BeneficiaryAutosData";
import BeneficiaryRecomendationsData from "../content/Beneficiary/BeneficiaryRecomendationsData";
import BeneficiaryEmergencyContact from "../content/Beneficiary/BeneficiaryEmergencyContact";
import BeneficiaryWorkingData from "../content/Beneficiary/BeneficiaryWorkingData";
import BeneficiaryBillData from "../content/Beneficiary/BeneficiaryBillData";
import ChildPersonalData from "../content/Child/ChildPersonalData";
import ChildHomeData from "../content/Child/ChildHomeData";
import ChildEmergencyContact from "../content/Child/ChildEmergencyContact";
import ChildWorkingData from "../content/Child/ChildWorkingData";
import SpousePersonalData from "../content/Spouse/SpousePersonalData";
import SpouseContactData from "../content/Spouse/SpouseContactData";
import SpouseHomeData from "../content/Spouse/SpouseHomeData";
import SpouseEmergencyContact from "../content/Spouse/SpouseEmergencyContact";
import SpouseWorkingData from "../content/Spouse/SpouseWorkingData";
import Loader from "../core/Loader";

export default {
  name: "Documents",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    Btn,
    Input,
    Popup,
    //BeneficiaryModal,
    //PropertyTitleModal,
    //RecommendationsModal,
    Accordion,
    AccordionHeader,
    BeneficiaryPersonalData,
    BeneficiaryContactData,

    BeneficiaryHomeData,
    BeneficiaryAutosData,
    BeneficiaryRecomendationsData,
    BeneficiaryEmergencyContact,
    BeneficiaryWorkingData,
    BeneficiaryBillData,
    ChildPersonalData,
    ChildHomeData,
    ChildEmergencyContact,
    ChildWorkingData,
    SpousePersonalData,
    SpouseContactData,
    SpouseHomeData,
    SpouseEmergencyContact,
    SpouseWorkingData,
    ValidationError,
    Loader,
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  data() {
    return {
      btnState: "disabled",
      requestIcon: "watch-default.svg",
      paymentIcon: "edit-default.svg",
      uploadDocsIcon: "watch-default.svg",
      requestSpanText: "Ver detalles",
      paymentSpanText: "Editar detalles",
      uploadSpanText: "Ver detalles",
      membership: "",
      showDataSpouse: true,
      showDataMenorChilds: true,
      showDataMayorChilds: true,
      showcheck: "",
      selectedChild: "mayorChild",
      showMenorChildForm: false,
      showMayorChildForm: false,
      mainBody: "",
      BeneficiaryMainBody: [],
      benficiaryBody: "",
      emergencyPhoneFromEmit: "",
      ALLDATA: "",
      SpouseID: "",
      spouseObject: "",
      ///////////
      childs: [],
      cars: [true],
      isComplete: true,
      isLoading: false,
      documentsApplicant: [],
      documentsCars: [],
      bodyBeneficiaries: [],
      remainigBeneficiaryData: [],
      remainingData: {},
      applicantData: null,
      applicantDataContact: null,
      applicantDataBilling: null,
      isReadyToFinish: false,
      childsSave: 0,
      errorForm: "",
      childProfOfAddress: null
    };
  },
  computed: {
    ...mapGetters({
      nombre: "getName",
      firstName: "getName",
      maritalStatus: "getMaritalStatus",
      applicationData: "getUserApplication",
      allApplicationData: "getAllApplicationData",
      addressApplicant: "getAddress",
      proofAddressApplicant: "getProofAddress",
      beneficiaries: "getBeneficiariesData",
    }),
    showFirstName() {
      return this.firstName;
    },

    showApplicationData() {
      return this.applicationData;
    },

    userMembership() {
      if (this.applicationData.membership) {
        return this.applicationData.membership.membershipName;
      }
    },

    userMaritalStatus() {
      if (this.maritalStatus == "MARRIED") {
        return "CASADO";
      }
      if (this.maritalStatus == "SINGLE") {
        return "SOLTERO";
      }
      if (this.maritalStatus == "DIVORCED") {
        return "DIVORCIADO";
      }
      if (this.maritalStatus == "WIDOWED") {
        return "VIUDO";
      }
    },

    showAllApplicationData() {
      return this.allApplicationData;
    },
  },
  mounted() {
    window.scroll(0, 0);
    this.getApplicationData();
    for (
      let index = 1;
      index < this.showAllApplicationData.cars.length;
      index++
    ) {
      this.cars.push(true);
    }
  },
  created() {
    let maritalStatus = this.userMaritalStatus;
    let userMembership = this.userMembership;
    //console.log("maritalStatus -->", maritalStatus);
    //console.log("userMembership -->", userMembership);
    this.showFormsData(maritalStatus, userMembership);
    this.ALLDATA = this.showAllApplicationData;
    let profA = this.showAllApplicationData.documents.filter(function (item) {
      return item.documentType == "PROOF_OF_ADDRESS";
    })
    if (profA.length > 0) {
      let aux = this
      toDataURL(profA[0].publicUrl, function (dataUrl) {
        aux.childProfOfAddress = dataUrl.split(",")[1]
      })

    }

    //console.log("ALLDATA -->", this.ALLDATA);
    //1.- Creo el json
    this.createMainBody();
    this.createBeneficiaryMainBody();
  },
  updated() {
    let maritalStatus = this.userMaritalStatus;
    let userMembership = this.userMembership;
    //console.log("maritalStatus -->", maritalStatus);
    //console.log("userMembership -->", userMembership);
    this.showFormsData(maritalStatus, userMembership);
    this.ALLDATA = this.showAllApplicationData;
    //console.log("ALLDATA -->", this.ALLDATA);
    //1.- Creo el json
    this.createMainBody();
    this.createBeneficiaryMainBody();
  },

  methods: {
    getProofAddressFromUrl() {

      let ProofOfAddressDocuments = {
        documentType: "PROOF_OF_ADDRESS",
        value: "child_proof_of_address",
        extension: "pdf",
        mimeType: "application/pdf",
        content: this.childProfOfAddress,
      };



      return ProofOfAddressDocuments;

    },
    async send() {
      try {
        this.isLoading = true;
        let response = await this.sendFinish();
        if (response.data.status == 200) {
          this.$refs.toFinish.toggleModal();
          this.isLoading = false;
          Swal.fire({
            title:
              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>DOCUMENTACION FINALIZADA</span>",
            html:
              "<div>" +
              "<p class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'></p>" +
              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
              "</div>",
            width: "50rem",
            padding: "2rem",
            showConfirmButton: true,

            confirmButtonText: "Aceptar",
            confirmButtonColor: "#dc7134",
            customClass: {
              confirmButton: "t1-btn t1-btn--primary-block",
            },
            showCloseButton: true,
            onClose: () => {
              this.$router.push("/home/");
            },
          });
        }
      } catch (error) {
        this.isLoading = false;
        this.$refs.toFinish.toggleModal();
        alert("ERROR");
        //console.log(error.response.data.message);
      }
    },
    ...mapActions([
      "checkApplication",
      "PostDataBenefiaciary",
      "applicantRemaining",
      "postBeneficiaries",
      "postBeneficiariesRemaining",
      "sendFinish",
    ]),
    closeMessageError() {
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
          "<p>Asegurate de haber guardado tus últimos cambios en tus datos antes de salir.</p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        showCancelButton: true,
        width: "50rem",
        padding: "2rem",
        cancelButtonText: "CANCELAR",
        confirmButtonText: "SALIR DE TODAS MANERAS",
        confirmButtonColor: "#dc7134",
        customClass: {
          cancelButton: "t1-btn t1-btn--ghost",
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        reverseButtons: true,
        onClose: () => { },
      }).then((result) => {
        if (result.value) {
          this.$router.push("/home");
        }
      });
    },
    addChild() {
      this.$refs.childPopUp.toggleModal();
      if (this.childs.length < 8) {
        if (this.selectedChild == "mayorChild") {
          this.childs.push(true); ///<- SI ES TRUE ES HIJO MAYOR
        } else {
          this.childs.push(false);
        }
      }
    },
    deleteChildren(index) {
      this.childs.splice(index, 1)
    },
    addCar() {
      if (this.cars.length < 7) {
        this.cars.push(true);
      }
    },
    deleteCar(indexDelete) {

      this.cars.splice(indexDelete, 1)
    },
    async getApplicationData() {
      let response = await this.checkApplication();
      let hijos = response.data.data.beneficiaries.filter(function (item) {
        return item.beneficiaryType != "SPOUSE"
      })

      this.childs = [];
      if (hijos.length > 0) {
        for (let index = 0; index < hijos.length; index++) {
          if (hijos[index].beneficiaryType == "OLDER_CHILD")
            this.childs.push(true)
          else
            this.childs.push(false)
        }

        this.childsSave = hijos.length;

      }
    },

    mouseOverIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-hover.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-hover.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-hover.svg`;
      }
    },
    mouseLeaveIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-default.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-default.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-default.svg`;
      }
    },
    mouseDownIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-click.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-click.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-hover.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-hover.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-hover.svg`;
      }
    },

    showFormsData(maritalStatus, membership) {
      //console.log("membership -->", membership);
      //console.log("maritalStatus -->", maritalStatus);

      // option 1
      if (maritalStatus == "CASADO" && membership == "Familiar") {
        //console.log("opcion 1");
        this.showDataSpouse = true;
        this.showDataMenorChilds = true;
      }

      // option 2
      if (maritalStatus == "SOLTERO" && membership == "Familiar") {
        //console.log("opcion 2");
        this.showDataSpouse = false;
        this.showDataMenorChilds = true;
      }
      // option 3
      if (maritalStatus == "DIVORCIADO" && membership == "Familiar") {
        //console.log("opcion 3");
        this.showDataSpouse = false;
        this.showDataMenorChilds = true;
      }

      // option 4
      if (maritalStatus == "VIUDO" && membership == "Familiar") {
        //console.log("opcion 4");
        this.showDataSpouse = false;
        this.showDataMenorChilds = true;
      }

      // option 5
      if (maritalStatus == "SEPARADO" && membership == "Familiar") {
        //console.log("opcion 5");
        this.showDataSpouse = false;
        this.showDataMenorChilds = true;
      }

      // option 6
      if (
        maritalStatus == "CASADO" &&
        (membership == "Ejecutiva 2Px" || membership == "Ejecutiva 3Px")
      ) {
        //console.log("opcion 6");
        this.showDataSpouse = false;
        this.showDataMenorChilds = false;
      }

      // option 7
      if (
        maritalStatus == "SOLTERO" &&
        (membership == "Ejecutiva 2Px" || membership == "Ejecutiva 3Px")
      ) {
        //console.log("opcion 7");
        this.showDataSpouse = false;
        this.showDataMenorChilds = false;
      }

      // option 8
      if (
        maritalStatus == "DIVORCIADO" &&
        (membership == "Ejecutiva 2Px" || membership == "Ejecutiva 3Px")
      ) {
        //console.log("opcion 8");
        this.showDataSpouse = false;
        this.showDataMenorChilds = false;
      }

      // option 9
      if (
        maritalStatus == "VIUDO" &&
        (membership == "Ejecutiva 2Px" || membership == "Ejecutiva 3Px")
      ) {
        //console.log("opcion 9");
        this.showDataSpouse = false;
        this.showDataMenorChilds = false;
      }

      // option 10
      if (
        maritalStatus == "SOLTERO" &&
        (membership == "Ejecutiva 2Px" || membership == "Ejecutiva 3Px")
      ) {
        //console.log("opcion 10");
        this.showDataSpouse = false;
        this.showDataMenorChilds = false;
      }

      // option 11
      if (
        maritalStatus == "SEPARADO" &&
        (membership == "Ejecutiva 2Px" || membership == "Ejecutiva 3Px")
      ) {
        //console.log("opcion 11");
        this.showDataSpouse = false;
        this.showDataMenorChilds = false;
      }
    },

    showSavedPopUp() {
      this.$refs.savePopup.toggleModal();
    },

    closeSavedPoUp() {
      this.$refs.savePopup.toggleModal();
      this.$router.push("/home");
    },

    CloseChildForm() {
      this.$refs.childPopUp.toggleModal();

      if (this.selectedChild == "mayorChild") {
        this.showMayorChildForm = true;
        this.showMenorChildForm = false;
      } else {
        this.showMenorChildForm = true;
        this.showMayorChildForm = false;
      }
    },

    createMainBody() {
      // 1.- get data from showAllApplicationData
      let personalMailfromHeader = this.showAllApplicationData.personalMail;
      let phonesfromHeader = this.showAllApplicationData.phones;
      let addressfromHeader = this.showAllApplicationData.address;
      let billingInfofromHeader = this.showAllApplicationData
        .billingInformation;
      let documentsListfromHeader = this.showAllApplicationData.documentsList;
      let carsfromHeader = this.showAllApplicationData.cars;

      // //console.log("personalMailfromHeader", personalMailfromHeader);
      // //console.log("phonesfromHeader", phonesfromHeader);
      // //console.log("addressfromHeader", addressfromHeader);
      // //console.log("documentsListfromHeader", documentsListfromHeader);
      // //console.log("billingInfofromHeader", billingInfofromHeader);
      // //console.log("carsfromHeader", carsfromHeader);

      // Obtengo el id del beneficiario Cónyuge
      let Beneficiaries = this.showAllApplicationData.beneficiaries;
      for (let i = 0; i < Beneficiaries.length; i++) {
        if (Beneficiaries[i].beneficiaryType == "SPOUSE") {
          this.SpouseID = Beneficiaries[i].id;
          //console.log("SpouseID", this.SpouseID);
        }
      }

      this.mainBody = {
        phones: [],
      };

      // 2.- Phones
      if (phonesfromHeader != "" && phonesfromHeader != undefined) {
        for (var i = 0; i < phonesfromHeader.length; i++) {
          this.mainBody.phones.push({
            phone: phonesfromHeader[i].phoneNumber,
            contactName: phonesfromHeader[i].contactName,
            contactRelationship: phonesfromHeader[i].contactRelationship,
            phoneType: phonesfromHeader[i].phoneType,
          });
        }
      }

      // 3.- Address *** Si la NO direccion es nula, la insertamos en el mainBody
      if (addressfromHeader != "" && addressfromHeader != undefined) {
      }

      // 4.- billingInformation
      if (billingInfofromHeader) {
      }

      // 5.- documentsLists
      if (
        documentsListfromHeader != "" &&
        documentsListfromHeader != undefined
      ) {
      }

      // 6.- Cars
      if (carsfromHeader != "" && carsfromHeader != undefined) {
      }

      //console.log("mainBody final -->", this.mainBody);
    },

    createBeneficiaryMainBody() {
      this.BeneficiaryMainBody = {
        remainingBeneficiaryData: [],
      };

      let Beneficiaries = this.showAllApplicationData.beneficiaries;

      if (Beneficiaries != null || Beneficiaries != undefined) {
        for (let i = 0; i < Beneficiaries.length; i++) {
          this.BeneficiaryMainBody.remainingBeneficiaryData.push({
            id: Beneficiaries[i].id,
          });
        }

        // Asigno el objeto spouseObject
        let AllBeneficiary = this.BeneficiaryMainBody.remainingBeneficiaryData;
        for (let i = 0; i < AllBeneficiary.length; i++) {
          let index = AllBeneficiary.map(function (obj) {
            return obj.id;
          }).indexOf(this.SpouseID);
          this.spouseObject = AllBeneficiary[index];
          //console.log("allBeneficary Index", index);
          //console.log("spouseObject", this.spouseObject);
        }
      }

      //console.log("BeneficiaryMainBody", this.BeneficiaryMainBody);
    },

    async checkDataJson() {
      this.isComplete = true;
      this.documentsCars = [];
      this.documentsApplicant = [];
      this.remainigBeneficiaryData = [];
      //1.- Titular Contacto ==============
      let BeneficiaryContactResponse = await this.$refs.contactBeneficiaryData.getFormdata();

      if (BeneficiaryContactResponse) {
        this.applicantDataContact = BeneficiaryContactResponse;
      } else {
        this.errorForm = "Los datos de <b>Contacto de Titular</b> están incompletos. Por favor, ingresa todos los datos."
        this.isComplete = false;
      }

      //2.- Titular  Domicilio ==============
      let BeneficiaryHomeResponse = await this.$refs.HomeBeneficiaryData.getFormdata();

      if (BeneficiaryHomeResponse) {
        // //console.log("DIRECCION DEL TITULAR");
        this.documentsApplicant.push(this.proofAddressApplicant);
      } else {
        this.errorForm = "Los datos de <b>Domicilio del Titular</b> están incompletos. Por favor, ingresa todos los datos."
        this.isComplete = false;
      }

      //3.- Titular Contacto de Emergencia  ==============
      let BeneficiaryEmergencyResponse = await this.$refs.EmergBeneficiaryData.getFormdata();
      if (BeneficiaryEmergencyResponse) {
        this.applicantData = BeneficiaryEmergencyResponse;
      } else {
        this.errorForm = "Los datos del <b>Contacto de emergencia del Titular</b> están incompletos. Por favor, ingresa todos los datos."
        this.isComplete = false;
      }

      //4.- Titular Billing  ==============
      let BeneficiaryBillingResponse = await this.$refs.BeneficiaryBillingData.getFormdata();
      if (BeneficiaryBillingResponse) {
        this.applicantDataBilling = BeneficiaryBillingResponse;
        if (BeneficiaryContactResponse) {
          this.applicantDataBilling.phone = this.applicantDataContact[0].phones[0].phone;
          this.applicantDataBilling.email = this.applicantDataContact[1].email;
        }
      } else {
        this.errorForm = "Los datos de <b>Facturación del Titular</b> están incompletos. Por favor, ingresa todos los datos.";
        this.isComplete = false;
      }

      //5.- Titular Autos  ==============

      for (let index = 0; index < this.cars.length; index++) {
        let BeneficiaryAutosResponse = await this.$refs[
          "AutosBeneficiaryData" + index
        ][0].addAuto();
        if (BeneficiaryAutosResponse) {
          this.documentsCars.push(BeneficiaryAutosResponse[0].autos[0]);
          if (BeneficiaryAutosResponse[1].documents[0].content != null)
            this.documentsApplicant.push(
              BeneficiaryAutosResponse[1].documents[0]
            );
        } else {
          this.errorForm = "Los datos de los <b>Autos</b> están incompletos. Por favor, ingresa todos los datos.";
          this.isComplete = false;
        }
      }

      // Para los datos del conyuge ==================================

      if (this.userMembership == "Familiar" && this.userMaritalStatus == "CASADO") {
        //7.- Spouse contact info  ==============
        let contactSpouseDataResponse = await this.$refs.contactSpouseData.getFormdata();

        if (!contactSpouseDataResponse) {
          this.errorForm = "Los datos de <b>Contacto del Cónyuge</b> están incompletos. Por favor, ingresa todos los datos.";
          this.isComplete = false;
        }

        //8.- Spouse HOME info  ==============
        let HomeSpouseDataResponse = await this.$refs.homeSpouseData.getFormdata();

        if (!HomeSpouseDataResponse) {

          this.errorForm = "Los datos de <b>Dirección del Cónyuge</b> están incompletos. Por favor, ingresa todos los datos.";
          this.isComplete = false;
        }

        ///EMERGENCY DATA INFO

        let EmergSpouseData = await this.$refs.EmergSpouseData.getFormdata();

        if (!EmergSpouseData) {
          this.errorForm = "Los datos de <b>Contacto de emergencia</b> del Cónyuge están incompletos. Por favor, ingresa todos los datos.";
          this.isComplete = false;
        }

        // //console.log(contactSpouseDataResponse);
        // //console.log(EmergSpouseData);

        //ARMAR EL BODY Y GUARDARLO EN STORE
        let spouse = this.beneficiaries.filter(function (item) {
          return item.beneficiaryType == "SPOUSE"
        })


        if (this.isComplete && spouse[0].address == null) {
          let phonesArray = contactSpouseDataResponse[0].phones;
          phonesArray.push(EmergSpouseData);

          this.remainingData = {
            id: spouse[0].id,
            personalMail: contactSpouseDataResponse[1].email,
            phones: phonesArray,
            address:
              HomeSpouseDataResponse == true
                ? this.addressApplicant
                : HomeSpouseDataResponse[0].address,
            documentsList: [
              HomeSpouseDataResponse == true
                ? this.proofAddressApplicant
                : HomeSpouseDataResponse[1].documents,
            ],
          };
          this.remainigBeneficiaryData.push(this.remainingData);

        }

      }

      ////LOS HIJOS SI ES QUE TIENE
      // console.log(structuredClone(this.beneficiaries));
      // if (this.userMembership == "Familiar") {
      if (this.childs.length > 0) {
        this.bodyBeneficiaries = [];

        let dataHijos = this.beneficiaries.filter(function (item) {
          return item.beneficiaryType != "SPOUSE"
        })

        for (let index = 0; index < this.childs.length; index++) {
          // console.log(this.$refs[
          //   "ChildPersonalData" + index
          // ]);
          let ChildPersonalData = await this.$refs[
            "ChildPersonalData" + index
          ][0].getFormdata();

          // console.log(ChildPersonalData);
          if (ChildPersonalData) {
            //console.log(ChildPersonalData);
          } else {
            this.errorForm = "Los datos <b>Personales de los hijos</b> están incompletos. Por favor, ingresa todos los datos.";
            this.isComplete = false;
            break;
          }

          let ChildHomeData = await this.$refs[
            "ChildHomeData" + index
          ][0].getFormdata();
          // console.log(ChildHomeData);
          if (ChildHomeData) {
            if (ChildHomeData == true) {
              //console.log("misma direccion");
            }
          } else {
            this.errorForm = "Los datos del <b>Domicilio de los hijos</b> están incompletos. Por favor, ingresa todos los datos.";
            this.isComplete = false;
            break;
          }

          let ChildEmergencyContact = await this.$refs[
            "ChildEmergencyContact" + index
          ][0].getFormdata();

          if (ChildEmergencyContact) {
            //console.log(ChildEmergencyContact);
          } else {
            this.errorForm = "Los datos del <b>Contacto de emergencia de los hijos</b> están incompletos. Por favor, ingresa todos los datos.";
            this.isComplete = false;
            break;
          }

          let ChildWorkingData = null;
          // console.log(this.$refs["ChildWorkingData" + index]);

          if (this.childs[index]) {
            ///ES MAYOR
            ChildWorkingData = await this.$refs[
              "ChildWorkingData" + index
            ][0].getFormdata();
            // console.log(ChildWorkingData);
            if (ChildWorkingData) {
              // console.log(ChildWorkingData);
            } else {
              this.errorForm = "Los datos <b>laborales de los hijos mayores</b> están incompletos. Por favor, ingresa todos los datos.";
              this.isComplete = false;
            }
          }

          let bodyBenef = {
            beneficiaryType: this.childs[index]
              ? "OLDER_CHILD"
              : "MINOR_CHILD",
            lastName: ChildPersonalData.lastName,
            motherLastName: ChildPersonalData.motherLastName,
            name: ChildPersonalData.name,
            birthDate: ChildPersonalData.birthDate,
            birthPlace: ChildPersonalData.birthPlace,
            documentsDTO: ChildPersonalData.documentsDTO,
          };

          if (ChildWorkingData) {
            bodyBenef.laborDataDTO = ChildWorkingData[0].laborData;
            if (ChildWorkingData[0].laborData.working) {
              ChildPersonalData.documentsDTO.push(ChildWorkingData[1].documents)
            }
          }
          // console.log(structuredClone(bodyBenef));
          this.bodyBeneficiaries.push(bodyBenef);

          let phonesArray = [];
          phonesArray.push(ChildEmergencyContact);

          this.remainingData = {
            id: ChildPersonalData.documentsDTO[0].value,
            // personalMail: ChildPersonalData.documentsDTO[0].value+"@example.com",
            phones: phonesArray,
            address:
              ChildHomeData == true
                ? this.addressApplicant
                : ChildHomeData[0].address,
            documentsList: [
              ChildHomeData == true
                ? this.proofAddressApplicant != null ? this.proofAddressApplicant : this.getProofAddressFromUrl()
                : ChildHomeData[1].documents,
            ],
          };
          // console.log(structuredClone(this.remainingData));
          if (index < dataHijos.length) {
            if (dataHijos[index].address == null)
              this.remainigBeneficiaryData.push(this.remainingData);
          }
          else {
            this.remainigBeneficiaryData.push(this.remainingData);
          }
          // console.log(structuredClone(this.remainingData));
        }
        // console.log(structuredClone(this.remainingData));
        // console.log(structuredClone(this.bodyBeneficiaries));
      }
      //}

      if (this.isComplete) {
        // console.log(1);
        this.sendToFinish();
      } else {

        Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>" + this.errorForm + ".</p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",

          width: "50rem",
          padding: "2rem",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc7134",
          customClass: {
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          onClose: () => {
            this.isLoading = false;
            window.scroll(0, 0);
          },
        })
          .then((result) => { });

      }
    },

    async saveRemamingDataApplicant(data) {
      try {
        let response = await this.applicantRemaining(data);
        if (response.data.status == 200) {
          this.isLoading = false;
          this.isReadyToFinish = true;
          Swal.fire({
            title:
              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>DOCUMENTACION GUARDADA Y LISTA PARA ENVIAR</span>",
            html:
              "<div>" +
              "<p class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'></p>" +
              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
              "</div>",
            width: "50rem",
            padding: "2rem",
            showConfirmButton: false,
            showCloseButton: true,
            onClose: () => { },
          });
          return true;
        }
      } catch (error) {
        this.isLoading = false;
        return false;
      }
    },

    async saveBeneficiaries(data) {
      try {
        await this.postBeneficiaries(data);
        return true;
      } catch (error) {

        if (error.response.status == 409) {
          let msg = error.response.data.errorDetails ? error.response.data.errorDetails : 'La CURP proporcionada ya esta registrada.';
          Swal.fire({
            title:
              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
            html:
              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
              "<p>" + msg + "</p>" +
              "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
              "</div>",
            allowOutsideClick: false,
            width: "50rem",
            padding: "2rem",
            confirmButtonText: "Ok",
            confirmButtonColor: "#dc7134",
            customClass: {
              confirmButton: "t1-btn t1-btn--primary-block",
            },
            reverseButtons: true,
            onClose: () => {
              this.isLoading = false;
              return false;
            },
          }).then((result) => { });
        }

        return false;
      }
    },

    async sendToFinish() {
      // this.$refs.toFinish.toggleModal();
      this.isLoading = true;
      //alert("PROCESO FINALIZADO");

      try {

        if (this.userMembership == "Familiar") {

          //AGREGAR HIJOS
          for (let index = this.childsSave; index < this.childs.length; index++) {
            // console.log(structuredClone(this.bodyBeneficiaries[index]));
            if (
              !(await this.saveBeneficiaries(this.bodyBeneficiaries[index]))
            ) {
              throw "error";
            }
          }

          //INFORMACION RESTANTE DEL ESPOSA Y DE LOS HIJOS
          let response = await this.checkApplication();
          //console.log(this.remainigBeneficiaryData)
          //if (this.maritalStatus == "MARRIED") {
          // var hijos = response.data.data.beneficiaries.filter(function (item) {
          //   return item.beneficiaryType != "SPOUSE";
          // });
          var hijos = response.data.data.beneficiaries;
          // console.log(structuredClone(hijos));
          // console.log(structuredClone(this.remainigBeneficiaryData));

          for (let index = 0; index < this.remainigBeneficiaryData.length; index++) {


            //this.remainigBeneficiaryData[index+1].id = hijos[index].id;

            for (let index2 = 0; index2 < hijos.length; index2++) {
              var documentsHijo = hijos[index2].documents

              var curpHijo = documentsHijo.filter(function (item) {
                return item.documentType == "CURP"
              })
              // console.log(curpHijo[0].value);
              // console.log(this.remainigBeneficiaryData[index].id);
              if (curpHijo[0].value.toLocaleLowerCase() == this.remainigBeneficiaryData[index].id.toLocaleLowerCase()) {
                this.remainigBeneficiaryData[index].id = hijos[index2].id;
              }
            }

          }
          //}

          let body = {
            remainingBeneficiaryData: this.remainigBeneficiaryData,
          };
          // console.log(structuredClone(body));

          if (this.remainigBeneficiaryData.length > 0) {
            // try {
            await this.postBeneficiariesRemaining(body);
            /* } catch (error) {
              this.isLoading = false;
              return false;
            } */
          }

        }

        ///INFORMACION RESTANTE DEL SOLICITANTE
        if (this.showAllApplicationData.billingInformation == null) {
          let phonesArray = this.applicantDataContact[0].phones;
          phonesArray.push(this.applicantData);

          let bodyApplicant = {
            personalMail: this.applicantDataContact[1].email,
            phones: phonesArray,
            address: this.addressApplicant,
            billingInformation: this.applicantDataBilling,
            documentsList: this.documentsApplicant,
            cars: this.documentsCars,
          };

          if (!(await this.saveRemamingDataApplicant(bodyApplicant))) {
            throw "error";
          }

        } else {
          this.isLoading = false;
          this.isReadyToFinish = true;
          Swal.fire({
            title:
              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>DOCUMENTACION GUARDADA Y LISTA PARA ENVIAR</span>",
            html:
              "<div>" +
              "<p class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'></p>" +
              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
              "</div>",
            width: "50rem",
            padding: "2rem",
            showConfirmButton: false,
            showCloseButton: true,
            onClose: () => { },
          });
        }
      } catch (error) {
        //console.log(error);
        this.isLoading = false;

        if (!Swal.isVisible()) {
          Swal.fire({
            icon: 'error',
            title:
              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
            html:
              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
              "<p>A ocurrido un error al intentar guardar su información.</p>" +
              "</div>",
            confirmButtonColor: "#dc7134",
            customClass: {
              confirmButton: "t1-btn t1-btn--primary-block",
            },
            onClose: () => {
              window.scroll(0, 0);
            },
            willOpen: () => {

            }
          });
        }

        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.btn-add-right {
  position: relative;
  padding-right: 12rem;
  text-align: right;

  @media (max-width: 50rem) {
    padding-right: 2rem;
  }
}

.btn-submit-docs {
  padding-right: 12rem;
  padding-top: 3rem;
  padding-bottom: 6rem;
  text-align: right;

  @media (max-width: 50rem) {
    padding-right: 2rem;
  }
}

.documents-section {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.documents-section .accordion-header {
  background-color: #3a8a65;
  width: 100%;
  height: auto;
  color: #fff;
  text-align: left;
  font-weight: 600;
  font-size: 1.8rem;
  margin-left: auto;
  margin-right: auto;
  padding: 1.5rem 2rem;
  border-radius: 0.5rem;
}

.documents-section .accordion-content {
  width: 100%;
  height: auto;
  margin: 0 auto;
  margin-bottom: 40px;
  background: #fff;
  padding: 20px 20px 20px 20px;
  border-radius: 0.5rem;
}

.documents-section .info {
  width: 80%;
  height: auto;
  margin: 0 auto;
}

.accordion-section {
  width: 85%;
  height: auto;
  margin: 0 auto;
  padding-bottom: 20px;
}

.accordion-section .content-info {
  width: 95%;
  height: auto;
  margin: 0 auto;
  padding: 50px 31px 0px 31px;
  background: #fff;
  padding-bottom: 20px;
}

.custom-btn-saved {
  color: #f78c4f;
  background-color: #fff !important;
}

.btn-section {
  width: 80%;
  height: auto;
  margin: 0 auto;
  padding-bottom: 20px;
}

.btn-show-child {
  width: 200px;
  height: auto;
  float: right;
}

.btn-add-child {
  margin-top: 20px;
}

.title-pop-child {
  font-weight: 600;
  color: #dc7134;
  margin-bottom: 20px;
}

.subtitle-pop-child {
  font-size: 18px;
  line-height: 22px;
  color: #285f46;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.text-pop-child {
  display: block;
  font-size: 1.4rem;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.radio-buttons label {
  display: block;
  color: #828282;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-right: 15px;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #f78c4f;
  background-color: #f78c4f;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 15px;
  height: 15px;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.text-style {
  font-size: 27px;
  color: #285f46;
  font-weight: 600;
  text-transform: uppercase;
}

.divLine {
  width: 100%;
  border: 0.1rem solid #828282;
}
</style>
